'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinkElement = getLinkElement;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxHistoryComponent = require('redux-history-component');

var _reduxHistoryComponent2 = _interopRequireDefault(_reduxHistoryComponent);

var _LinkAction = require('./LinkAction');

var _LinkAction2 = _interopRequireDefault(_LinkAction);

var _LinkContent = require('./LinkContent');

var _LinkContent2 = _interopRequireDefault(_LinkContent);

var _LinkExternal = require('./LinkExternal');

var _LinkExternal2 = _interopRequireDefault(_LinkExternal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Get the link type. Three kinds:
// 1. Action button. { action: function }
// 1. External link. { href: string }
// 1. Internal link. { routeId: string, ...params }
// import { pick } from 'lodash'


function getLinkElement(_ref) {
  var action = _ref.action,
      href = _ref.href,
      routeId = _ref.routeId;
  if (action) return _LinkAction2.default;
  if (href) return _LinkExternal2.default;
  if (routeId) return _reduxHistoryComponent2.default;
  return null;
} // Link Router. Decide if it's internal, external, or an action button.
// import css from 'cape-style'


function Link(props) {
  var Component = getLinkElement(props);
  if (!Component) return _react2.default.createElement(_LinkContent2.default, props); // Do we want to send LinkContent to LinkInternal?

  return _react2.default.createElement(Component, props, _react2.default.createElement(_LinkContent2.default, props));
}

Link.propTypes = {
  action: _propTypes2.default.func,
  href: _propTypes2.default.string,
  routeId: _propTypes2.default.string // siteId: PropTypes.string,

};
Link.defaultProps = {
  action: null,
  href: null,
  routeId: null
};
exports.default = Link;